<template lang="pug">
section.pessoa
    BaseHeader(
        :titulo='$t("mensagens.pessoas.titulo")',
        icon='mdi mdi-account-plus',
        :btnTexto='$t("mensagens.pessoas.cadastrarPessoa")',
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarRepresentante'
    )

    .view-container-base-header
        .d-flex
            .pessoa__barra-pesquisa
                i.el-icon-search
                input.lista-pessoa__barra-pesquisa__input(
                    v-model='search',
                    type='text',
                    :placeholder='isAlvorada ? "Procure pelo nome, CPF/CNPJ ou BP Pessoa" : $t("mensagens.pessoas.placeholder")',
                    autocomplete='off',
                    @keyup.enter='onChangeSearchInput'
                )

            el-dropdown.action-button(trigger='click')
                el-button.btn-exportar-relatorio(
                    icon='el-icon-download',
                    type='primary',
                    v-if='permissaoAmbiente(ambientes.BRASIL)'
                ) &nbsp;&nbsp;&nbsp; {{ $t('mensagens.exportacao.exportar') }}
                el-dropdown-menu(slot='dropdown')
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(true)'
                    ) {{ $t('mensagens.exportacao.simples') }}
                    el-dropdown-item(
                        icon='el-icon-download',
                        @click.native='exportarRelatorio(false)'
                    ) {{ $t('mensagens.exportacao.completa') }}

        .pessoa__tabela
            el-table.table-representantes(
                :key="listagemTableKey('representantes', representantes, paginacao.paginaAtual)",
                height='100%',
                :data='representantes',
                @sort-change='ordenarRepresentantesPeloNome',
                style='width: 100%'
            )
                el-table-column(
                    prop='nomeRazaoSocial',
                    :label='$t("mensagens.pessoas.tabela.nome")',
                    sortable='custom',
                    min-width='200'
                )

                el-table-column(
                    prop='documento',
                    :label='permissaoAmbiente(ambientes.ARGENTINA) ? $t("mensagens.pessoas.tabela.cuit") : permissaoAmbiente(ambientes.PARAGUAY) ? $t("mensagens.pessoas.tabela.numeroRuc") : $t("mensagens.pessoas.tabela.documento")',
                    min-width='150'
                )
                    .template(slot-scope='scope')
                        span {{ scope.row.documento | VMask(formatCpfCnpjTableColumn(scope.row)) }}

                el-table-column(
                    prop='email',
                    :label='$t("mensagens.comuns.email")',
                    min-width='250'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.ARGENTINA) || permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='telefono',
                    :label='$t("mensagens.pessoas.tabela.telefoneContato")',
                    min-width='150'
                )
                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='direccion',
                    :label='$t("mensagens.pessoas.endereco")',
                    min-width='150'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.ARGENTINA)',
                    prop='localidadeNivelUmNome',
                    :label='$t("mensagens.pessoas.tabela.provincia")',
                    min-width='150'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.ARGENTINA)',
                    prop='localidadeNivelDoisNome',
                    :label='$t("mensagens.pessoas.tabela.departamento")',
                    min-width='150'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='localidadeNivelUmNome',
                    :label='$t("mensagens.pessoas.tabela.departamento")',
                    min-width='150'
                )

                el-table-column(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    prop='localidadeNivelDoisNome',
                    :label='$t("mensagens.pessoas.tabela.distrito")',
                    min-width='150'
                )
                el-table-column(
                    v-if='permissaoAmbiente(ambientes.ARGENTINA)',
                    prop='localidadeNivelTresNome',
                    :label='$t("mensagens.pessoas.tabela.localidade")',
                    min-width='150'
                )

                el-table-column(
                    prop='idCliente',
                    :label='isAlvorada ? "BP Pessoa" : $t("mensagens.pessoas.tabela.idPessoa")',
                    min-width='100'
                )

                el-table-column(
                    min-width='100',
                    align='center',
                    :label='$t("mensagens.pessoas.tabela.acoes")'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='editarRepresentante(scope.row.id)'
                                ) {{ $t('mensagens.comuns.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='handleOpenModalDeleteRepresentante(scope.row)'
                                ) {{ $t('mensagens.comuns.remover') }}

                                el-dropdown-item(
                                    v-if='permissaoAmbiente(ambientes.BRASIL)',
                                    icon='flow flow-environment',
                                    @click.native='abrirModalDiagnosticoSocioambiental(scope.row)'
                                ) {{ $t('mensagens.pessoas.diagnosticoSocioambiental') }}

                template(slot='empty')
                    el-empty(
                        :description='$t("mensagens.pessoas.voceNaoPossuiPessoasCadastradas")'
                    )

            .tabela-rodape.paginacao-direita
                .tabela-rodape--esquerda
                    p {{ totalRepresentantes }} {{ $t('mensagens.pessoas.pessoas') }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalRepresentantes',
                        @current-change='atualizarPagina'
                    )

    #modal-delete-representante-are-you-sure.row(
        v-show='deleteRepresentanteModal'
    )
        el-dialog(
            :visible.sync='deleteRepresentanteModal',
            width='500px',
            :before-close='handleCloseModalDeleteRepresentante'
        )
            .column.d-flex.justify-content-center.align-items-center.flex-column
                h2.font-weight-bold.mb-5
                    | {{ $t('mensagens.pessoas.atencao') }}
                h4.text-center.mb-4(
                    v-if='deleteRepresentanteVinculadoModal',
                    style='word-break: keep-all'
                )
                    | {{ $t('mensagens.pessoas.possuiTerritoriosVinculados') }}
                h4.text-center.mb-4(style='word-break: keep-all')
                    | {{ $t('mensagens.pessoas.desejaRemover') }}
                br
                .buttons.col-12.row.justify-content-between
                    button.px-5.btn.btn-cancel.btn-block.w-40(
                        @click='handleCloseModalDeleteRepresentante'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    button.delete.px-5.btn.el-button--primary.btn-block.btn-add-diagnostic.w-40(
                        @click='deleteRepresentante'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    ModalEditarCadastrarRepresentante(
        :mostrar='mostrarModalEditarCadastrarRepresentante',
        :dadosRepresentante='dadosRepresentanteCadastro',
        :editar='editar',
        @atualizarListaRepresentantes='fetchRepresentantes',
        @fechar='fecharModalEditarCadastrarRepresentante'
    )

    ModalDiagnosticoSocioambientalRepresentante(
        :mostrar='mostrarModalDiagnosticoSocioambiental',
        :dadosRepresentante='dadosRepresentanteDiagnostico',
        @fechar='mostrarModalDiagnosticoSocioambiental = false'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import EmptyResult from '@/components/EmptyResult.vue';
import ModalDiagnosticoSocioambientalRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';
import ModalEditarCadastrarRepresentante from '@/components/ModalEditarCadastrarRepresentante.vue';
import validators from '@/utils/validators';
import formatters from '@/utils/formatters';
import representanteService from '@/services/RepresentanteService';
import { mapGetters, mapState } from 'vuex';
import UtilsService from '@/services/UtilsService';
import TerritorioService from '@/services/TerritorioService';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'index',
    components: {
        BaseHeader,
        EmptyResult,
        ModalDiagnosticoSocioambientalRepresentante,
        ModalEditarCadastrarRepresentante
    },

    data() {
        return {
            representantes: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 20
            },
            totalRepresentantes: 0,
            search: '',
            order: null,
            deleteRepresentanteModal: false,
            deleteRepresentanteVinculadoModal: false,
            selectedRepresentante: {},
            mostrarModalDiagnosticoSocioambiental: false,
            dadosRepresentanteDiagnostico: {},
            mostrarModalEditarCadastrarRepresentante: false,
            dadosRepresentanteCadastro: {},
            editar: false,
            ambientes: AmbientesEmpresas
        };
    },

    mounted() {
        this.fetchRepresentantes();
        if (this.$route.params.cadastrar) {
            this.mostrarModalEditarCadastrarRepresentante = true;
            this.editar = false;

            if (this.$route.params.cadastrar.length !== 1) {
                this.dadosRepresentanteCadastro = {
                    nomeRazaoSocial: this.$route.params.cadastrar
                };
            }
        }
    },

    computed: {
        pagedTableData() {
            return this.tableData.slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
            );
        },
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        ...mapState(['usuarioLogado'])
    },

    methods: {
        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },
        async exportarRelatorio(simplificado) {
            const url = 'representantes/exportar/' + simplificado;
            UtilsService.baixarArquivo(url);
        },

        atualizarPagina() {
            this.fetchRepresentantes();
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;

            filtro.searchText = this.search || '';

            if (validators.validarCpf(this.search)) {
                filtro.searchText = formatters.cpfCnpjFormatToNumeral(
                    this.search
                );
            }

            if (this.order != null) {
                filtro.order = `&sort=nome_razao_social,${this.order}`;
            } else {
                filtro.order = '&sort=nome_razao_social,asc';
            }

            return filtro;
        },

        formatarTextoBusca() {
            if (this.search) {
                const cpfCnpj = formatters.cpfCnpjFormatToNumeral(this.search);
                this.search = cpfCnpj === '' ? this.search : cpfCnpj;
            }
        },

        async fetchRepresentantes() {
            this.formatarTextoBusca();
            if (this.search.length === 0 || this.search.length > 2) {
                const { data } = await representanteService.findAllByFiltro(
                    this.getFiltros()
                );
                if (data && data.itens) {
                    this.representantes = data.itens;
                    this.totalRepresentantes = data.paginacao.total;
                } else {
                    // Caso não haja dados ou os dados sejam inesperados, inicializa corretamente
                    this.representantes = [];
                    this.totalRepresentantes = 0;
                }
            } else {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.pessoas.digiteTresCaracteresParaPesquisar'
                    )
                });
            }
        },

        cadastrarRepresentante() {
            const country = this.usuarioLogado.ambienteLogado;
            this.editar = false;

            switch (country) {
                case 'AR':
                    this.$router.push({name: 'CadastrarPessoaArgentina'});
                    break;
                default:
                    this.mostrarModalEditarCadastrarRepresentante = true;
            }
        },

        async editarRepresentante(id) {
            try {
                const { data } =
                    await representanteService.detalhesRepresentante(id);
                this.dadosRepresentanteCadastro = data;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroAoRemoverPessoa'
                    )
                });
            }

            this.editar = true;
            this.mostrarModalEditarCadastrarRepresentante = true;
        },
        fecharModalEditarCadastrarRepresentante() {
            this.dadosRepresentanteCadastro = {};
            this.mostrarModalEditarCadastrarRepresentante = false;
        },

        deleteRepresentante() {
            representanteService
                .delete(this.selectedRepresentante.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteRepresentanteModal = false;
                        this.$notify.success({
                            message: this.$t('mensagens.pessoas.pessoaRemovida')
                        });

                        this.reloadRepresentantes();
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.pessoas.erroAoRemoverPessoa'
                            )
                        });
                    }
                });
        },

        async handleOpenModalDeleteRepresentante(representante) {
            this.selectedRepresentante.id = representante.id;
            let hasBoundTerritoryResponse =
                await TerritorioService.verificarRepresentante(
                    representante.id
                );

            this.deleteRepresentanteModal = true;
            if (hasBoundTerritoryResponse.data) {
                this.deleteRepresentanteVinculadoModal = true;
            }
        },

        handleCloseModalDeleteRepresentante() {
            this.deleteRepresentanteModal = false;
            this.deleteRepresentanteVinculadoModal = false;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchRepresentantes();
        },

        formatCpfCnpjTableColumn({ documento }) {
            if (this.permissaoAmbiente(this.ambientes.ARGENTINA)) {
                return '##-########-#';
            } else if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                const digitos = (documento || '').replace(/\D/g, '');
                if (digitos.length === 7) return '######-#';
                if (digitos.length === 8) return '#######-#';
                if (digitos.length === 9) return '########-#';
                return '######-#';
            } else {
                return formatters.numeralStringFormatTocpfCnpj(documento);
            }
        },

        reloadRepresentantes() {
            // Caso só possua 1 representante na pagina e a página não for a primeira, força a atualização da página
            // para a anterior
            if (
                this.representantes &&
                this.representantes.length === 1 &&
                this.paginacao.paginaAtual > 1
            ) {
                this.paginacao.paginaAtual = this.paginacao.paginaAtual - 1;
            }
            this.fetchRepresentantes();
        },

        abrirModalDiagnosticoSocioambiental({ documento, nomeRazaoSocial }) {
            this.dadosRepresentanteDiagnostico = {
                nome: nomeRazaoSocial,
                documento: formatters.numeralStringFormatTocpfCnpj(documento)
            };
            this.mostrarModalDiagnosticoSocioambiental = true;
        },

        ordenarRepresentantesPeloNome(column) {
            const ordem = column.order === 'ascending' ? 1 : -1;
            this.representantes.sort(
                (a, b) =>
                    ordem *
                    a.nomeRazaoSocial.localeCompare(
                        b.nomeRazaoSocial,
                        'pt-BR',
                        { sensitivity: 'base' }
                    )
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.pessoa {
    height: 100%;
    width: 100%;

    .pessoa__barra-pesquisa {
        width: 95%;
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-pessoa__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .btn-exportar-relatorio {
        width: 200px;
        height: 46px;
    }

    .table-pessoa {
        height: 100%;
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .pessoa__tabela {
        height: calc(100vh - 312px);

        .el-table {
            border-radius: 5px 5px 0 0;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    button {
        width: fit-content;
        cursor: pointer;

        i {
            margin-right: 10px;
        }
    }

    #end-add-representante-button {
        p {
            cursor: pointer;
        }
    }

    .buttons .delete {
        margin-top: 0;
    }

    .el-table {
        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }
    }
}

.btn-exportar-relatorio {
    margin-left: 20px;
    width: 200px;
    height: 46px;
}

.form-control {
    height: 2.5em !important;
    margin-bottom: 1.5rem;
}

.modal-socioambiental {
    max-height: 500px;
    overflow: auto;
}

#modal-diagnostico-socioambiental {
    text-align: left;
}

#editRepresentanteButtons {
    button {
        width: 100px;
    }
}
</style>
